import {Card, Form, FormInstance, Input} from 'antd';
import React, {RefObject} from "react";
import IField, {RELATION_FIELD_TYPE} from "../../../../../../../model/interface/dataStorage/IField";
import {connect, RootStateOrAny} from "react-redux";
import selectors from "../../../../../../../redux/selectors";
import IRepositoryService from "../../../../../../../model/interface/IRepositoryService";
import IFieldOptions from "../../../../../../../model/interface/form/elementOptions/IFieldOptions";
import DataStorageService from "../../../../../../../model/service/dataStorage/DataStorageService";
import FieldContentTypeOptionsEditor, {
    IFieldContentTypeOptions
} from "../../../../content-type/field/optionEditors/FieldContentTypeOptionsEditor";
import IBaseProps from "../../../../../../../model/interface/IBaseProps";
import IContentType from "../../../../../../../model/interface/dataStorage/IContentType";


export interface IContentTypeEditorOptions extends IFieldContentTypeOptions {

}

interface IProps extends IBaseProps {
    onChange: (options: IFieldOptions, afterCallback?: () => void) => void
    options: IFieldOptions
    formRef: RefObject<FormInstance>
    findServiceByClassName: (name: string) => IRepositoryService,
    field: IField
    contentType: IContentType
}

interface IState {
}

class FormFieldContentTypeEditor extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.populateMandatoryOptions()
    }

    componentDidUpdate(/*prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any*/) {
        this.populateMandatoryOptions()
    }

    populateMandatoryOptions = () => {
        const {field} = this.props
        let update: any = {}
        if ([RELATION_FIELD_TYPE.MANY_TO_MANY, RELATION_FIELD_TYPE.ONE_TO_MANY].indexOf(field.type) >= 0 && !this.props.options.multiple) {
            update.multiple = true
        }
        const presenters = this.getService().getPresenterList()
        if (presenters.length === 1 && !this.props.options.contentTypePresenter) {
            update.contentTypePresenter = presenters[0].value
        }
        if (Object.keys(update).length > 0) {
            this.props.onChange({...this.props.options, ...update}, () => this.props.formRef.current?.resetFields(Object.keys(update)))
        }
    }

    getService(): IRepositoryService {
        const {field, findServiceByClassName} = this.props
        if (!field.targetEntity) {
            throw new Error(`Target entity not defined for contentType[${field.contentTypeId}] field[${field.name}]`)
        }

        let service: DataStorageService = findServiceByClassName(field.targetEntity) as DataStorageService
        if (!service) {
            throw new Error('Service for "' + field.targetEntity + '" is missing')
        }

        return service;
    }

    render() {
        const {options, history, match, contentType} = this.props
        const service = this.getService()
        const targetContentType = service.getContentType ? service.getContentType() : null


        return (
            <Card>
                <Form.Item label={"Typ obsahu"}>
                    <Input disabled value={service.getTitle()}/>
                </Form.Item>

                {targetContentType && (
                    <FieldContentTypeOptionsEditor buildFieldName={(...args) => args} targetContentType={targetContentType}
                                                   options={options} match={match} originalContentType={contentType}
                                                   history={history}/>
                )}
                {/*{this.props.options.multiple ? 'multiple' : 'N/A'}*/}
            </Card>
        )
    }
}

const mapStateToProps = (state: RootStateOrAny) => {
    return {
        findServiceByClassName: (name: string) => selectors.services.findOneByFullClassName(state, name),
    }
}
export default connect(mapStateToProps)(FormFieldContentTypeEditor)